export default "__VITE_ASSET__DYO4Isk$__"